import { render, staticRenderFns } from "./DetailListCell.vue?vue&type=template&id=6eb63019&scoped=true&"
import script from "./DetailListCell.vue?vue&type=script&lang=js&"
export * from "./DetailListCell.vue?vue&type=script&lang=js&"
import style0 from "./DetailListCell.vue?vue&type=style&index=0&id=6eb63019&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb63019",
  null
  
)

export default component.exports